import {
    markRaw,
} from 'vue';
import {
    defineStore,
} from 'pinia';

export const useModalStore = defineStore('modal', {
    state: () => ({
        active: false,
        ariaLabel: '',
        component: null,
        componentProps: {},
        focusElementSelector: null,
        showCloseButton: false,
        title: '',
        type: 'modal',
    }),
    actions: {
        show({
            ariaLabel = '',
            component = null,
            componentProps = {},
            focusElementSelector = null,
            showCloseButton = true,
            title = '',
            type = 'modal',
        }) {
            this.active = true;
            this.ariaLabel = ariaLabel || title;
            this.component = markRaw(component);
            this.componentProps = componentProps;
            this.focusElementSelector = focusElementSelector;
            this.showCloseButton = showCloseButton;
            this.title = title;
            this.type = type;
        },
        hide() {
            // Reset the component so the `unmounted` hook gets called
            // on modal components, see `AppModal.vue` for clarification.
            this.active = false;
            this.component = null;
        },
    },
});
